export type WordPath = {
  word: string;
  cells: [number, number][];
};

const createWordNumbers = (
  table: string[][],
  paths: WordPath[],
) => {
  const wordNumbers = new Map<string, number>();

  const rows = table.length;
  const columns = table[0].length;

  paths.forEach((path, index) => {
    const [startRow, startCol] = path.cells[0];

    let numberRow = startRow;
    let numberCol = startCol;


    if (path.cells.length === 1) {
      if (startCol === 0) {

        numberCol = -1;
      } else if (startCol === columns - 1) {

        numberCol = columns;
      } else if (startRow === 0) {
 
        numberRow = -1;
      } else if (startRow === rows - 1) {
   
        numberRow = rows;
      }
    }

    else {
      const [nextRow, nextCol] = path.cells[1];

      const rowDirection = nextRow - startRow;
      const colDirection = nextCol - startCol;

      if (startCol === 0) {
        numberCol = -1;
      }

      else if (startCol === columns - 1) {
        numberCol = columns;
      }

      else if (startRow === 0) {
        numberRow = -1;
      }

      else if (startRow === rows - 1) {
        numberRow = rows;
      }

      else if (colDirection === 1) {
        numberCol = -1;
      } else if (colDirection === -1) {
        numberCol = columns;
      } else if (rowDirection === 1) {
        numberRow = -1;
      } else if (rowDirection === -1) {
        numberRow = rows;
      }
    }

    wordNumbers.set(
      `${numberRow}-${numberCol}`,
      index + 1,
    );
  });

  return wordNumbers;
};

export default createWordNumbers;